import * as React from "react";
import {Field} from "react-final-form";
import {CanalesIngreso as canalesIngreso} from "../modelo/CanalesIngreso";

export default class CanalesIngreso extends React.Component<CanalesIngresoProps> {
    render() {
        const {className} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {canalesIngreso.map(gestion => {
                                return <option key={gestion} value={gestion}>{gestion}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }
}

interface CanalesIngresoProps {
    name: string,
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/CanalesIngreso.tsx